import React from 'react';
import PropTypes from 'prop-types';
import PortfolioItem from '@components/PortfolioItem';
import FlapBoard from '@components/FlapBoard';
import technicalItems from './technical-items';

import './style.scss';

const EXPERIENCE_ROW = [
  {
    text:   'EXPERIENCE',
    colors: ['teal','teal','teal','teal','teal','teal','teal','teal','teal','teal'],
  },
];

const TechnicalPage = (props, context) => {
  const { theme: { colorPrimary, colorAlternate, textAlternate } } = context;

  return (
    <div id="experience" className="technical-page">
      <div className="content-grid">
        <FlapBoard heading="h2" autoPlay={false} rows={EXPERIENCE_ROW} />
        <div className="technical-wrapper">
          <style jsx="true">{`
            .technical-item {
              background-color: ${colorPrimary};
              color: ${textAlternate};
            }
            .technical-item a {
              color: ${textAlternate};
            }
            .technical-item__links a:hover {
              border-bottom: 2px solid ${colorAlternate};
            }
            .portfolio-item {
              border-color: ${colorPrimary}28;
            }
            .portfolio-item:hover {
              border-color: ${colorPrimary};
              box-shadow: 0 0 16px ${colorPrimary}88, 0 0 32px ${colorPrimary}44;
            }
          `}</style>
          {technicalItems.map((item, i) => (
            <PortfolioItem render={item.render} key={i} />
          ))}
        </div>
      </div>
    </div>
  );
};

TechnicalPage.contextTypes = {
  theme: PropTypes.any
};

export default TechnicalPage;



// WEBPACK FOOTER //
// ./src/pages/TechnicalPage/TechnicalPage.js